import React from 'react';

const TestimonialsPage = () => {
    return (
        <div>
            <h1>Testimonials</h1>
        </div>
    );
};

export default TestimonialsPage;
